// extracted by css-extract-rspack-plugin
export default {"cls1":"Menu-cls1_EdN","cls2":"Menu-cls2_7mz Menu-cls1_EdN"};